// extracted by mini-css-extract-plugin
export var o_headboard2 = "headboard2-module--o_headboard2--e15c9";
export var o_headboard2__btn = "headboard2-module--o_headboard2__btn--3461f";
export var o_headboard2__container = "headboard2-module--o_headboard2__container--50859";
export var o_headboard2__desc = "headboard2-module--o_headboard2__desc--ada66";
export var o_headboard2__img = "headboard2-module--o_headboard2__img--fb9df";
export var o_headboard2__info = "headboard2-module--o_headboard2__info--740fe";
export var o_headboard2__subtitle = "headboard2-module--o_headboard2__subtitle--e98bc";
export var o_headboard2__title = "headboard2-module--o_headboard2__title--68c84";